import { InjectionToken } from '@angular/core';
import { TourBuilder } from './tour.types';

export const TOUR_BUILDERS = new InjectionToken<TourBuilder[]>('TOUR_BUILDERS');
